import type { ReactNode, CSSProperties } from "react";

export interface LayoutProps {
  children: ReactNode;
  className?: string;
  /** Vertical gap between children — defaults to 16px via the .bp-layout CSS class. */
  gap?: CSSProperties["gap"];
  /** Inline style escape hatch. */
  style?: CSSProperties;
}

/**
 * Base layout primitive — flex column with consistent vertical gap between
 * children (typically Blueprint <Section> components). Page and Overlay both
 * specialize this base. Not usually used directly; prefer Page or Overlay.
 */
export function Layout({ children, className, gap, style }: LayoutProps) {
  return (
    <div data-testid="layout"
      className={["bp-layout", className].filter(Boolean).join(" ")}
      style={gap !== undefined ? { ...style, gap } : style}
    >
      {children}
    </div>
  );
}
